import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import * as z from "zod";

export const previewEmailTemplate = {
  name: "previewEmailTemplate" as const,
  input: z.union([
    z.object({ templateId: z.string() }),
    z.object({ savedTemplateId: z.string() }),
    z.object({ template: emailTemplateSchema }),
    z.object({ originTemplateId: z.string() }),
  ]),
  output: z.string(),
};
